import { Button, Typography } from '@mui/material'
import { FastForward } from '@mui/icons-material'
import { Grid } from '../../../../components/UniversalComponents'
import SignalProfileManagerForm from '../../../../components/Admin/Signals/SignalProfileManager/SignalProfileManagerForm'

const Step2Boat = ({ setNextStep, permissionsCheck }) => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography
                    align="center"
                    variant="h5"
                    color="warning"
                    sx={{ margin: 2 }}
                >
                    If you already have a profile you can:
                    {
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => setNextStep(3)}
                            sx={{ width: 200, marginLeft: 5 }}
                            endIcon={<FastForward />}
                        >
                            Skip Step
                        </Button>
                    }
                </Typography>
            </Grid>
            <Grid item xs={12} sx={{ marginTop: 5 }}>
                <SignalProfileManagerForm
                    row={{}}
                    formDescription="Use this form to add a new Signal Profile within Osmosis Telematics Platform"
                    onClose={() => setNextStep(3)}
                    saveCache={() => {}}
                    permissionCheck={permissionsCheck}
                    quickStart={true}
                />
            </Grid>
        </Grid>
    )
}

export default Step2Boat
